<template>
  <div
    class="background-insight is-relative"
    :style="
      `background-size : ${diameter}px;
        width: ${diameter}px;
        height:${diameter}px;
        `
    "
  >
    <div v-for="checkbox in checkboxs" :key="checkbox.id_affichage_resultats">
      <div id="marker" v-if="!showDots"></div>
      <div
        v-if="(checkboxs.length || affichageNoms) && !showDots"
        :style="checkbox.coordinate"
        class="is-absolute hoverWrapper cursor-pointer small-text bold"
      >
        <!-- @click.exact="bringForward"
        @click.ctrl="bringBackward"-->
        <!-- si seulement des points avec des borders d'une seule couleur  -->
        <div
          v-if="checkbox.profil !== null ? checkbox.profil[0].length == 1 : ''"
          class="point"
          :class="classSingleBorder(checkbox)"
        >
          <p>{{ checkbox.id_affichage_resultats }}</p>
        </div>
        <!-- avec des borders avec plusieurs couleurs  -->
        <div
          v-if="checkbox.profil !== null ? checkbox.profil[0].length > 1 : ''"
        >
          <div class="border-point">
            <p>{{ checkbox.id_affichage_resultats }}</p>
          </div>
          <div
            class="border-point"
            v-if="checkbox.profil !== null ? checkbox.profil[0].length > 1 : ''"
            :class="classBorder(checkbox, 0)"
          ></div>
          <div
            class="border-point"
            v-if="checkbox.profil !== null ? checkbox.profil[0].length > 1 : ''"
            :class="classBorder(checkbox, 1)"
          ></div>
        </div>
        <div id="hoverShow1">
          <p style="color:black; text-shadow: 0px 0px 0px black;">
            {{ $t("admin.participantsCamembert.resultats") }}
            {{ checkbox.firstname }}{{ " " }}{{ checkbox.lastname }}
          </p>
          <div
            class="is-inline test123"
            v-for="(button, index2) in buttons.tabColorAdminResultats"
            :key="button.id"
          >
            <button
              @click="significationCouleur(index2)"
              :style="buttons.tabColorAdminResultats[index2]"
              class="button mt-1"
            >
              <p v-if="index2 === 1">{{ checkbox.color1 }}</p>
              <p v-if="index2 === 0">{{ checkbox.color2 }}</p>
              <p v-if="index2 === 3">{{ checkbox.color3 }}</p>
              <p v-if="index2 === 2">{{ checkbox.color4 }}</p>
            </button>
            {{ " " }}
          </div>
        </div>
      </div>
      <div class="nullify" v-if="showDots">
        <div
          :style="checkbox.coordinate"
          class="dot is-absolute hoverWrapper cursor-pointer"
        >
          <div id="hoverShow1">
            <p style="color:black; text-shadow: 0px 0px 0px black;">
              {{ $t("admin.participantsCamembert.resultats") }}
              {{ checkbox.firstname }}{{ " " }}{{ checkbox.lastname }}
            </p>
            <div
              class="is-inline test123"
              v-for="(button, index2) in buttons.tabColorAdminResultats"
              :key="button.id"
            >
              <button
                @click="significationCouleur(index2)"
                :style="buttons.tabColorAdminResultats[index2]"
                class="button mt-1"
              >
                <p v-if="index2 === 1">{{ checkbox.color1 }}</p>
                <p v-if="index2 === 0">{{ checkbox.color2 }}</p>
                <p v-if="index2 === 3">{{ checkbox.color3 }}</p>
                <p v-if="index2 === 2">{{ checkbox.color4 }}</p>
              </button>
              {{ " " }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import buttons from "../../data/questions.json";
import { mapGetters } from "vuex";

export default {
  props: {
    alwaysShow: {
      type: Boolean,
      default: false
    },
    affichageRoue: {
      type: Boolean
    },
    checkedRows: {
      type: Array
    },
    showDots: {
      type: Boolean,
      default: true
    },
    data: {
      type: Array
    },
    diameter: {
      type: Number,
      default: 300
    }
  },
  data: function() {
    return {
      showRows: this.checkRows,
      buttons: buttons,
      colors: [],
      checkboxs: JSON.parse(
        JSON.stringify(this.$store.getters.insight_checkrows_participants)
      ),
      participant: [],
      tabCoordinateTotal: [],
      id_affichage_resultats: -1,
      zIndex: 50,
      errors: []
    };
  },

  mounted() {
    this.getResults();
  },
  watch: {
    insight_checkrows_participants: [
      {
        handler: "getResults"
      }
    ]
  },
  computed: {
    ...mapGetters([
      "insight_checkrows_participants",
      "array_participants_termine"
    ])
  },
  methods: {
    // bringForward (e) {
    //   this.zIndex++;
    //   if (e.target.classList.contains("hoverWrapper")) {
    //     e.target.style["z-index"]++;
    //   } else {
    //     if (e.target.parentNode.classList.contains("hoverWrapper")) {
    //       e.target.parentNode.style["z-index"]++;
    //     } else {
    //       if (
    //         e.target.parentNode.parentNode.classList.contains("hoverWrapper")
    //       ) {
    //         e.target.parentNode.parentNode.style["z-index"]++;
    //       }
    //     }
    //   }

    //   // e.target.parentNode.parentNode.style += `z-index:${this.zIndex}`
    // },
    // bringBackward (e) {
    //   this.zIndex--;
    //   if (
    //     e.target.classList.contains("hoverWrapper") &&
    //     e.target.style["z-index"] >= 1
    //   ) {
    //     e.target.style["z-index"]--;
    //   } else {
    //     if (
    //       e.target.parentNode.classList.contains("hoverWrapper") &&
    //       e.target.parentNode.style["z-index"] >= 1
    //     ) {
    //       e.target.parentNode.style["z-index"]--;
    //     } else {
    //       if (
    //         e.target.parentNode.parentNode.classList.contains("hoverWrapper") &&
    //         e.target.parentNode.parentNode.style["z-index"] >= 1
    //       ) {
    //         e.target.parentNode.parentNode.style["z-index"]--;
    //       }
    //     }
    //   }

    //   // e.target.parentNode.parentNode.style += `z-index:${this.zIndex}`
    // },
    classSingleBorder(checkbox) {
      return `singleBorder${checkbox.profil[0][0]}`;
    },
    classBorder(checkbox, index) {
      if (index === 0) {
        return `border-halfCircleLeft${checkbox.profil[0][index]}`;
      } else {
        return `border-halfCircleRight${checkbox.profil[0][index]}`;
      }
    },
    getResults: function(tabTest) {
      if (!this.affichageRoue) {
        if (this.array_participants_termine.length > 0) {
          this.checkboxs = JSON.parse(
            JSON.stringify(this.array_participants_termine)
          );
          this.checkboxs = this.checkboxs.sort(function(a, b) {
            return a.id_affichage_resultats - b.id_affichage_resultats;
          });
        }
      } else {
        this.checkboxs = JSON.parse(
          JSON.stringify(this.insight_checkrows_participants)
        );
        this.checkboxs = this.checkboxs.sort(function(a, b) {
          return a.id_affichage_resultats - b.id_affichage_resultats;
        });
      }
      this.filterColors();
    },
    //Outputs a clear array of arrays containing every colors of each participants
    filterColors() {
      if (Array.isArray(this.checkboxs) && this.checkboxs.length > 0) {
        this.colors = [];
        let test = this.checkboxs;
        test.forEach(participant => {
          let color = [];

          color[0] = participant.color1;
          color[1] = participant.color2;
          color[2] = participant.color3;
          color[3] = participant.color4;
          this.colors.push(color);
        });
        this.drawParticipantsDots();
      } else {
        this.errors.push("error");
      }
    },
    indexOfMax(arr) {
      let myMaximums = [[], []];
      let orderedArr = arr.slice(0); //copy arr and break the reference
      myMaximums[0] = orderedArr
        .sort(function (a,b){return a-b})
        .reverse()
       .slice(0); //sort orderedArr and copy it in myMaximus
      let element;
      let indexes;
      for (let i = 0; i < arr.length; i++) {
        indexes = [];
        element = orderedArr[i];
        for (let j = 0; j < arr.length; j++) {
          //check the index of the element in the original array, thus giving it the color code, and check that it hasn't been added already to handle equalities
          if (arr[j] === element && !myMaximums[1].includes(j)) {
            indexes.push(arr.indexOf(element, j));
          }
        }
        myMaximums[1].push(...indexes); //break down the array indexes and push it into myMaximums
      }
      return myMaximums;
    },
    //For each participant, outputs a position depending on colors, from highest to lowest,
    drawParticipantsDots() {
      if (Array.isArray(this.colors) && this.colors.length > 0) {
        this.tabCoordinateTotal = [];
        for (let index = 0; index < this.colors.length; index++) {
          let participantColor = this.colors[index];
          let k = this.diameter / 57.1; // arbitrary factor to scale the dots to the size of the background
          let originX = this.diameter / 2 - 12;
          let originY = this.diameter / 2 - 12;
          let x = originX;
          let y = originY;
          //indexOfMax outputs an array of two arrays, first array contains the score of a color, ordered from high to low, second array contains the color's code
          let colorGradient = this.indexOfMax(participantColor);

          for (let i = 0; i < colorGradient[1].length; i++) {
            let gradientX = 0;
            let gradientY = 0;

            //Color code 0 = Red (or color1)
            //Color code 1 = Blue (or color2)
            //Color code 2 = Green (or color3)
            //Color code 3 = Yellow (or color4)

            switch (colorGradient[1][i]) {
              case 0:
                gradientX = colorGradient[0][i] * (k / ((i + 1) * 2));
                gradientY = -(colorGradient[0][i] * (k / ((i + 1) * 2)));
                break;

              case 1:
                gradientX = -(colorGradient[0][i] * (k / ((i + 1) * 2)));
                gradientY = -(colorGradient[0][i] * (k / ((i + 1) * 2)));
                break;

              case 2:
                gradientX = -(colorGradient[0][i] * (k / ((i + 1) * 2)));
                gradientY = colorGradient[0][i] * (k / ((i + 1) * 2));
                break;

              case 3:
                gradientX = colorGradient[0][i] * (k / ((i + 1) * 2));
                gradientY = colorGradient[0][i] * (k / ((i + 1) * 2));
                break;

              default:
                this.errors.push(`Error on index : ${index}`);
                break;
            }

            //handeling equalities
            //check if not a the end of the array
            if (i < colorGradient[0].length - 1) 
            {
              //check if next color is equal to current one
              if (colorGradient[0][i] === colorGradient[0][i + 1]) 
              {
                switch (colorGradient[1][i + 1]) {
                  case 0:
                    // if(colorGradient[1][i] === 0 || colorGradient[1][i] === 3){
                    gradientX =
                      gradientX + colorGradient[0][i] * (k / ((i + 1) * 2));
                    // }
                    // else if(colorGradient[1][i] === 1 || colorGradient[1][i] === 2){
                    gradientY =
                      gradientY +
                      -1 * (colorGradient[0][i] * (k / ((i + 1) * 2)));
                    // }
                    break;
                  case 1:
                    // if(colorGradient[1][i] === 0 || colorGradient[1][i] === 3){
                    gradientX =
                      gradientX +
                      -1 * (colorGradient[0][i] * (k / ((i + 1) * 2)));
                    // }
                    // else if(colorGradient[1][i] === 1 || colorGradient[1][i] === 2){
                    gradientY =
                      gradientY +
                      -1 * (colorGradient[0][i] * (k / ((i + 1) * 2)));
                    // }
                    break;
                  case 2:
                    // if(colorGradient[1][i] === 0 || colorGradient[1][i] === 3){
                    gradientX =
                      gradientX +
                      -1 * (colorGradient[0][i] * (k / ((i + 1) * 2)));
                    // }
                    // else if(colorGradient[1][i] === 1 || colorGradient[1][i] === 2){
                    gradientY =
                      gradientY + colorGradient[0][i] * (k / ((i + 1) * 2));
                    // }
                    break;
                  case 3:
                    // if(colorGradient[1][i] === 0 || colorGradient[1][i] === 3){
                    gradientX =
                      gradientX + colorGradient[0][i] * (k / ((i + 1) * 2));
                    // }
                    // else if(colorGradient[1][i] === 1 || colorGradient[1][i] === 2){
                    gradientY =
                      gradientY + colorGradient[0][i] * (k / ((i + 1) * 2));
                    // }

                    break;

                  default:
                    this.errors.push(`Error on index : ${index}`);
                    break;
                }
                i = i + 3;
              }
            }
            x += gradientX;
            y += gradientY;
          }
          let indexing = 0;
         while (
            Math.sqrt(
              (x - this.diameter / 2.15) * (x - this.diameter / 2.15) +
                (y - this.diameter / 2.15) * (y - this.diameter / 2.15)
            ) >
              this.diameter / 2 &&
            indexing < 200
          ) {
            if (x < this.diameter / 5) {
              x += this.diameter / 40;
            }
            if (x > this.diameter - this.diameter / 5) {
              x -= this.diameter / 40;
            }
            if (y < this.diameter / 5) {
              y += this.diameter / 40;
            }
            if (y > this.diameter - this.diameter / 5) {
              y -= this.diameter / 40;
            }
            indexing++;
          }
          this.tabCoordinateTotal.push(`top: ${y}px;left: ${x}px;`);
          if (this.checkboxs[index] !== undefined) {
            this.checkboxs[index].coordinate = `top: ${y}px;left: ${x}px;`;
          } else {
            return false;
          }
        }
      }
    }
  }
};
</script>

<style>
.singleBorder0 {
  box-sizing: content-box;
  border: 4px solid #ed5b07;
}
.singleBorder1 {
  box-sizing: content-box;
  border: 4px solid #448dfe;
}
.singleBorder2 {
  box-sizing: content-box;
  border: 4px solid #9edb58;
}
.singleBorder3 {
  box-sizing: content-box;
  border: 4px solid #f6da50;
}

.nullify {
  height: 0px;
  width: 0px;
  left: 0px;
  position: absolute;
}

.dot {
  width: 8px;
  height: 8px;
  margin-left: 8px;
  margin-top: 8px;
  background-color: rgb(255, 255, 255);
  position: relative;
  border: 1px solid rgb(0, 0, 0);
  border-radius: 4px;
}

.background-insight {
  background-image: url("~@/assets/img/circleProfeel2.svg");
  height: 400px;
  width: 400px;
  left: 0%;
  position: absolute;
}

.hoverWrapper:hover #hoverShow1 {
  display: block;
  color: black;
}

.hoverWrapper #hoverShow1 {
  display: none;
  position: absolute;
  background-color: white;
  border: 1px rgb(221, 221, 221) solid;
  min-width: 250px;
  border-radius: 0.2em;
  padding: 1em;
  height: auto;
  left: -70px;
  top: 30px;
  z-index: 99;
}

.point {
  height: 20px;
  width: 20px;
  background-color: white;
  z-index: 1;
  box-shadow: 0.1px 0.1px 7px rgb(226, 226, 226);
  position: relative;
  border-radius: 15px;
}

.border-point {
  height: 20px;
  width: 20px;
  background-color: white;
  z-index: 1;
  position: relative;
  border-radius: 20px;
  bottom: 2px;
  margin-left: 5px;
}

.is-absolute {
  position: absolute;
}

.cursor-pointer {
  cursor: pointer;
}

.border-halfCircleLeft0 {
  background-color: #ed5b07;
  box-shadow: 0.1px 0.1px 7px rgb(226, 226, 226);
  width: 14px;
  height: 28px;
  border-radius: 28px 0px 0px 28px;
  position: relative;
  z-index: 0;
  bottom: 26px;
  right: 7px;
}
.halfCircleLeft0 {
  background-color: #ed5b07;
  width: 10px;
  height: 100%;
  border-radius: 10px 0px 0px 10px;
}
.border-halfCircleLeft1 {
  background-color: #448dfe;
  box-shadow: 0.1px 0.1px 7px rgb(226, 226, 226);
  width: 14px;
  height: 28px;
  border-radius: 28px 0px 0px 28px;
  position: relative;
  z-index: 0;
  bottom: 26px;
  right: 7px;
}
.halfCircleLeft1 {
  background-color: #448dfe;
  width: 10px;
  height: 100%;
  border-radius: 10px 0px 0px 10px;
}
.border-halfCircleLeft2 {
  background-color: #9edb58;
  box-shadow: 0.1px 0.1px 7px rgb(226, 226, 226);
  width: 14px;
  height: 28px;
  border-radius: 28px 0px 0px 28px;
  position: relative;
  z-index: 0;
  bottom: 26px;
  right: 7px;
}
.halfCircleLeft2 {
  background-color: #9edb58;
  width: 10px;
  height: 100%;
  border-radius: 10px 0px 0px 10px;
}
.border-halfCircleLeft3 {
  background-color: #f6da50;
  box-shadow: 0.1px 0.1px 7px rgb(226, 226, 226);
  width: 14px;
  height: 28px;
  border-radius: 28px 0px 0px 28px;
  position: relative;
  z-index: 0;
  bottom: 26px;
  right: 7px;
}
.halfCircleLeft3 {
  background-color: #f6da50;
  width: 10px;
  height: 100%;
  border-radius: 10px 0px 0px 10px;
}
.border-halfCircleRight0 {
  background-color: #ed5b07;
  box-shadow: 0.1px 0.1px 7px rgb(226, 226, 226);
  width: 16px;
  height: 28px;
  z-index: 0;
  position: relative;
  border-radius: 0px 28px 28px 0px;
  bottom: 54px;
  left: 7px;
}
.halfCircleRight0 {
  background-color: #ed5b07;
  width: 10px;
  height: 100%;
  border-radius: 0px 10px 10px 0px;
  position: relative;
  bottom: 20px;
  left: 10px;
}
.border-halfCircleRight1 {
  background-color: #448dfe;
  box-shadow: 0.1px 0.1px 7px rgb(226, 226, 226);
  width: 16px;
  height: 28px;
  z-index: 0;
  position: relative;
  border-radius: 0px 28px 28px 0px;
  bottom: 54px;
  left: 7px;
}
.halfCircleRight1 {
  background-color: #448dfe;
  z-index: 100;
  width: 10px;
  height: 100%;
  border-radius: 0px 10px 10px 0px;
  position: relative;
  bottom: 20px;
  left: 10px;
}
.border-halfCircleRight2 {
  background-color: #9edb58;
  box-shadow: 0.1px 0.1px 7px rgb(226, 226, 226);
  width: 16px;
  height: 28px;
  z-index: 0;
  position: relative;
  border-radius: 0px 28px 28px 0px;
  bottom: 54px;
  left: 7px;
}
.halfCircleRight2 {
  background-color: #9edb58;
  width: 10px;
  height: 100%;
  border-radius: 0px 10px 10px 0px;
  position: relative;
  bottom: 20px;
  left: 10px;
}
.border-halfCircleRight3 {
  background-color: #f6da50;
  box-shadow: 0.1px 0.1px 7px rgb(226, 226, 226);
  width: 16px;
  height: 28px;
  z-index: 0;
  position: relative;
  border-radius: 0px 28px 28px 0px;
  bottom: 54px;
  left: 7px;
}
.halfCircleRight3 {
  background-color: #f6da50;
  width: 10px;
  height: 100%;
  border-radius: 0px 10px 10px 0px;
  position: relative;
  bottom: 20px;
  left: 10px;
}
</style>
